module.exports = __webpack_public_path__ + "img/logo.1a4538e1.png";